import { keyframes, styled } from "../../styles/tokens";

const slideIn = keyframes({
  "0%": {
    transform: "translateY(100%)",
    opacity: 0,
  },
  "100%": {
    transform: "translateY(0)",
    opacity: 1,
  },
});

const slideOut = keyframes({
  "0%": {
    transform: "translateY(0)",
    opacity: 1,
  },
  "100%": {
    transform: "translateY(100%)",
    opacity: 0,
  },
});

export const PopupContainer = styled("div", {
  position: "fixed",
  bottom: "24px",
  right: "24px",
  zIndex: 1000,

  display: "flex",
  alignItems: "center",
  gap: "16px",

  padding: "16px 20px",

  backgroundColor: "$white",
  borderRadius: "8px",
  boxShadow:
    "0px 4px 20px rgba(0, 0, 0, 0.15), -2px 0px 8px rgba(0, 0, 0, 0.08)",

  animation: `${slideIn} 0.3s ease-out forwards`,

  variants: {
    isClosing: {
      true: {
        animation: `${slideOut} 0.3s ease-out forwards`,
      },
    },
  },
});

export const PopupText = styled("span", {
  fontFamily: "$openSans",
  fontSize: "$text-lg",
  fontWeight: 400,
  color: "$black",
  whiteSpace: "nowrap",
});

export const RefreshButton = styled("button", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  height: "32px",
  padding: "0 20px",

  backgroundColor: "var(--colors-button-background)",
  border: "none",
  borderRadius: "8px",

  fontFamily: "$openSans",
  fontSize: "$text-lg",
  fontWeight: 600,
  color: "$white",
  textTransform: "uppercase",
  letterSpacing: "0.5px",

  cursor: "pointer",
  transition: "background-color 0.2s ease",

  "&:hover": {
    backgroundColor: "var(--colors-button-hover-background)",
  },

  "&:focus": {
    outline: "none",
  },

  "&:active": {
    backgroundColor: "var(--colors-button-active-background)",
  },
});

export const DismissButton = styled("button", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  height: "32px",
  padding: "0 12px",

  backgroundColor: "transparent",
  border: "none",

  fontFamily: "$openSans",
  fontSize: "$text-lg",
  fontWeight: 600,
  color: "var(--colors-button-background)",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  opacity: 0.6,

  cursor: "pointer",
  transition: "opacity 0.2s ease",

  "&:hover": {
    opacity: 1,
  },

  "&:focus": {
    outline: "none",
  },
});
